import type { DocumentationChecklist } from "@/features/dashboard/types/documentation-checklist";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryOptions } from "@tanstack/react-query";
import documentationChecklistService from "../services/documentation-checklist-service";

// Query options for documentation checklists
export const documentationChecklistsQueryOptions = (params: Record<string, unknown> = {}) =>
	queryOptions({
		queryKey: ["documentation-checklists", params],
		queryFn: () => documentationChecklistService.list(params),
	});

export const documentationChecklistQueryOptions = (id: string) =>
	queryOptions({
		queryKey: ["documentation-checklist", id],
		queryFn: () => documentationChecklistService.findById(id),
		enabled: !!id,
	});

// Mutations
export const useDocumentationChecklistCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: Partial<DocumentationChecklist>) => documentationChecklistService.create(data as DocumentationChecklist),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["documentation-checklists"] });
		},
	});
};

export const useDocumentationChecklistUpdateMutation = (id: string) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: Partial<DocumentationChecklist>) => documentationChecklistService.updateById(id, data as DocumentationChecklist),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["documentation-checklists"] });
			queryClient.invalidateQueries({ queryKey: ["documentation-checklist", id] });
		},
	});
};

export const useDocumentationChecklistDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => documentationChecklistService.deleteById(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["documentation-checklists"] });
		},
	});
};
